import config from "../config";
import { ErrorWithLocale, GlobalError } from "../interfaces";
import request, { requestOptionsFormData } from "../utils/request";

type UpdateTemplateResponse = {
  ok: boolean;
  error?: ErrorWithLocale;
};

const ConversationApi = {
  newConversationV2: async (formData: FormData) => {
    const options = await requestOptionsFormData(formData, true);
    const url = `${config.API_ROOT}/app/new-conversation`;
    const { data, err }: { data: UpdateTemplateResponse; err: GlobalError } =
      await request(url, options);
    if (err) {
      throw err;
    }

    return data;
  },
};

export default ConversationApi;
